// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"563":"9adc301c","619":"0852348f"}[chunkId] + ".chunk.js";
};